import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { H2 } from 'foundations-components/transitional/components/H2';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import ModalVideoSection from './ModalVideoSection';
import ModalPricingSection from './ModalPricingSection';
// @ts-expect-error Could not find a declaration file for module
import blobsUrl from 'bender-url!../../../images/blob-modal-header.svg';
import { Image } from 'foundations-components/transitional/components/Image';
// @ts-expect-error Could not find a declaration file for module
import { getAcademyToSoftwareModalTriggerSource } from '../../selectors/academyToSoftwareSelectors';
// @ts-expect-error Could not find a declaration file for module
import { showTooltip } from '../../actions/AcademyToSoftware';
import UsageTracker from '../../utils/UsageTracker';

// @ts-expect-error Could not find a declaration file for module
import { HotjarTrigger } from 'LearningCenterUI/components/Hotjar';

// @ts-expect-error Could not find a declaration file for module
import { fetchAccounts } from '../../actions/AccountsActions';
// @ts-expect-error Could not find a declaration file for module
import { requestProducts } from '../../actions/ProductsActions';
import { useRouteMatch } from 'react-router-dom';
import { UserAttributeKeys } from '../../features/userAttributes';
import { useUserAttribute } from '../../features/userAttributes/userAttributesQueries';
import { useRecommendationsTopicPreference } from '../../features/recommendations/recommendationsQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const topicToHub = {
  marketing: 'marketing',
  sales: 'sales',
  'customer-service': 'service',
  service: 'service'
};
const hubs = ['marketing', 'sales', 'service'];
const SoftwareDesirabilityModal = ({
  onClose
}) => {
  const dispatch = useDispatch();
  const {
    recommendationsTopicPreference: topicPreference
  } = useRecommendationsTopicPreference();
  const modalTriggerSource = useSelector(getAcademyToSoftwareModalTriggerSource);
  const accountsNotFetched = useSelector(state => state.accounts.get('data') === null && !state.accounts.get('isRequesting') && !state.accounts.get('hasError'));
  const productsNotFetched = useSelector(state => state.products.get('data') === null && !state.products.get('isRequesting') && !state.products.get('hasError'));
  const hubPreference = topicPreference && topicPreference in topicToHub && hubs.includes(topicToHub[topicPreference]) ? topicToHub[topicPreference] : 'marketing';
  const [selectedHub, setSelectedHub] = useState(hubPreference);
  const {
    path
  } = useRouteMatch();
  const isWizardOpen = path === '/wizard';
  const {
    isMobile
  } = useMediaQuery();
  const {
    userAttribute: hasSeenCloseTooltipAttribute
  } = useUserAttribute(UserAttributeKeys.HAS_SEEN_CLOSE_TOOLTIP);
  useEffect(() => {
    if (accountsNotFetched) {
      dispatch(fetchAccounts());
    }
    if (productsNotFetched) {
      dispatch(requestProducts());
    }
  }, [accountsNotFetched, dispatch, productsNotFetched]);
  useEffect(() => {
    setSelectedHub(hubPreference);
  }, [hubPreference]);
  useEffect(() => {
    UsageTracker.track('interaction', {
      action: 'academy-to-software-modal-viewed',
      hubPreference,
      topicPreference
    });
  }, [hubPreference, topicPreference]);
  return /*#__PURE__*/_jsxs(Modal, {
    "data-selected-software": selectedHub,
    "data-test-id": "academy-to-software-desirability-modal",
    dialogStyles: isMobile ? {
      blockSize: `auto !important`
    } : undefined,
    use: "conversational",
    width: 1234,
    children: [/*#__PURE__*/_jsx(HotjarTrigger, {
      name: "academy-to-software-modal-view"
    }), /*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.softwareDesirability.modal.title"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => {
          onClose();
          UsageTracker.track('interaction', {
            action: 'academy-to-software-modal-close-clicked'
          });
          if (modalTriggerSource === 'INFO_BUTTON' && !hasSeenCloseTooltipAttribute && !isWizardOpen) {
            dispatch(showTooltip());
          }
        }
      })]
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "700",
      marginInline: "auto",
      paddingInline: isMobile ? '400' : '0',
      textAlign: "center",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.softwareDesirability.modal.subHeading"
      })
    }), !isMobile && /*#__PURE__*/_jsx(View, {
      borderBlockStartColor: "border-core-subtle",
      borderBlockStartStyle: "solid",
      borderWidth: "100",
      marginBlockEnd: "700",
      marginInline: "1000",
      paddingInline: '1000',
      children: /*#__PURE__*/_jsx(Image, {
        src: blobsUrl
      })
    }), /*#__PURE__*/_jsx(Flex, {
      flexDirection: isMobile ? 'column' : 'row',
      gap: isMobile ? '100' : '300',
      justifyContent: "center",
      paddingInline: isMobile ? '400' : '1000',
      children: hubs.map(hub => /*#__PURE__*/_jsx(SelectableButton, {
        alignItems: "center",
        "data-test-id": `software-desirability-modal-tab-${hub}`,
        display: "flex",
        justifyContent: "center",
        maxBlockSize: "50px",
        minInlineSize: "200px",
        onSelectedChange: () => {
          UsageTracker.track('interaction', {
            action: 'academy-to-software-modal-hub-tab-changed',
            hubPreference,
            topicPreference,
            previousHub: selectedHub,
            newHub: hub
          });
          setSelectedHub(hub);
        },
        selected: selectedHub === hub,
        size: "auto",
        textLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.softwareDesirability.modal.hubs.${hub}.name`
        })
      }, hub))
    }), /*#__PURE__*/_jsx(ModalVideoSection, {
      hub: selectedHub,
      onCTAClick: onClose
    }), /*#__PURE__*/_jsx(ModalPricingSection, {
      hub: selectedHub,
      onCTAClick: onClose,
      priceLoading: productsNotFetched
    })]
  });
};
export default SoftwareDesirabilityModal;